/**
 * User & People Icons
 *
 * Icons for user profiles, contacts, teams, and people-related features.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser as fadUser,
  faUserCircle as fadUserCircle,
  faUsers as fadUsers,
  faUserPen as fadUserPen,
  faUserPlus as fadUserPlus,
  faUserFriends as fadUserFriends,
  faUserShield as fadUserShield,
  faPeopleGroup as fadPeopleGroup,
  faIdCard as fadIdCard,
  faAddressBook as fadAddressBook,
  faFaceSmile as fadFaceSmile,
  faLockOpen as fadLockOpen,
  faCreditCard as fadCreditCard,
  faGamepadModern as fadGamepadModern,
  faHandsPraying as fadHandsPraying,
  faEarthAmericas as fadEarthAmericas,
  faScreenUsers as fadScreenUsers,
  faBuildingMemo as fadBuildingMemo,
  faChildReaching as fadChildReaching,
  faChalkboardUser as fadChalkboardUser,
  faSchool as fadSchool,
  faSchoolFlag as fadSchoolFlag,
  faBooks as fadBooks,
  faBookOpenCover as fadBookOpenCover,
  faHousePersonLeave as fadHousePersonLeave,
  faUniversalAccess as fadUniversalAccess,
  faToothbrush as fadToothbrush,
  faToilet as fadToilet,
  faClothesHanger as fadClothesHanger,
  faPlateUtensils as fadPlateUtensils,
  faPerson as fadPerson,
  faTaxiBus as fadTaxiBus,
  faHandHoldingHand as fadHandHoldingHand,
  faHandHoldingDollar as fadHandHoldingDollar,
  faWineGlass as fadWineGlass,
  faSmoking as fadSmoking,
  faKey as fadKey,
  faFolderHeart as fadFolderHeart,
  faBell as fadBell,
  faRocketLaunch as fadRocketLaunch,
  faLockKeyhole as fadLockKeyhole,
  faAddressCard as fadAddressCard,
  faFileCircleQuestion as fadFileCircleQuestion,
  faBuildingColumns as fadBuildingColumns,
  faReceipt as fadReceipt,
  faArrowRightArrowLeft as fadArrowRightArrowLeft
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faUsers as fasUsers,
  faUserMinus as fasUserMinus,
  faPhone as fasPhone,
  faKey as fasKey,
  faUserPlus as fasUserPlus,
  faBell as fasBell,
  faList as fasList,
} from '@fortawesome/pro-solid-svg-icons';

export const loadUserIcons = () => {
  library.add(
    fadUser,
    fadUserCircle,
    fadUsers,
    fadUserPen,
    fadUserPlus,
    fadUserFriends,
    fadUserShield,
    fadPeopleGroup,
    fadIdCard,
    fadAddressBook,
    fadFaceSmile,
    fasUsers,
    fadLockOpen,
    fadCreditCard,
    fasUserMinus,
    fasPhone,
    fadGamepadModern,
    fadHandsPraying,
    fadEarthAmericas,
    fadScreenUsers,
    fadBuildingMemo,
    fadChildReaching,
    fadChalkboardUser,
    fadSchool,
    fadSchoolFlag,
    fadBooks,
    fadBookOpenCover,
    fadHousePersonLeave,
    fadUniversalAccess,
    fadToothbrush,
    fadToilet,
    fadClothesHanger,
    fadPlateUtensils,
    fadPerson,
    fadTaxiBus,
    fadHandHoldingHand,
    fadHandHoldingDollar,
    fadWineGlass,
    fadSmoking,
    fadKey,
    fasKey,
    fasUserPlus,
    fadFolderHeart,
    fadBell,
    fasBell,
    fadRocketLaunch,
    fadLockKeyhole,
    fadAddressCard,
    fasList,
    fadFileCircleQuestion,
    fadBuildingColumns,
    fadReceipt,
    fadArrowRightArrowLeft,
  );
};
